import PropTypes from 'prop-types'

const button = (props) => {
    let { className, raised, outlined, secondary, ...remainingProps } = props

    className = className ? className + ' btn' : 'btn'

    if (secondary)
        className += ' btn--secondary'

    if (raised)
        className += ' btn--raised'
    else if (outlined)
        className += ' btn--outlined'

    return (
        <button className={className} {...remainingProps}>{props.children}</button>
    )
}

button.propTypes = {
    raised: PropTypes.bool,
    outlined: PropTypes.bool,
    secondary: PropTypes.bool
}

export default button